<script setup>
import Divider from '@/Components/Divider.vue';
import IcoSpinner from '@/Images/IcoSpinner.vue';
import LoginForm from '@/Pages/Firebase/Auth/LoginForm.vue';
import LoginSocial from '@/Pages/Firebase/Auth/LoginSocial.vue';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import SecondaryButton from '@/Components/SecondaryButton.vue';
import { ref, watch } from 'vue';

import { locale } from '@/Localization.js';
import { trans, transChoice } from 'laravel-vue-i18n';

const props = defineProps({
    goToStep: { type: Function, },
    switched: { type: Boolean, default: false },
    user: { type: Object },
    subscription: { type: Object },
    last_subscription_is_processing: { type: Boolean, },
    last_subscription_is: { type: [Boolean, String, null], },
    show_social_connexion: { type: Boolean, default: true, },
    show_stripe_offers: { type: Boolean, default: false, },
});

const emit = defineEmits(['goToStep']);
const switched = ref(props.switched);

watch(() => props.user,
    () => {
        if (props.user) {
            switched.value = false;
        }
    }
);

</script>
<template>
    <header class="my-6 text-center">
        <h2 class="text-xl font-bold">{{ trans("Bonjour et bienvenue sur votre service de méditation") }}</h2>
        <p>{{ trans("Pour commencer, activez votre code ou connectez vous") }}&nbsp;:</p>
    </header>

    <div v-show="!switched" class="py-4 text-center max-w-md mx-auto">

        <h3 class="font-bold text-3xl mb-6">
            {{ trans("J’ai un code MeditBe") }}
        </h3>

        <PrimaryButton v-if="!(user && last_subscription_is == 'ACTIVE')" @click="emit('goToStep', 1)">
            <template v-if="show_stripe_offers">
                {{ trans("Je choisis mon offre") }}
            </template>
            <template v-else>
                {{ trans("J’active mon code") }}
            </template>
        </PrimaryButton>

        <Divider :label="trans('Ou')" class="py-8 text-xl text-black font-bold" />

        {{ trans('Vous pouvez accéder à ${anchor}.', { link: route('customer.app.index', { locale: locale }), anchor: 'votre espace méditation' }) }}

        <div v-show="!!user && last_subscription_is" class="mt-6 p-4 my-4">
            <div class="flex items-center text-left justify-center max-h-96 overflow-auto font-semibold">
                <IcoSpinner v-show="!!last_subscription_is_processing" />
                <div v-if="!!user && last_subscription_is == 'ACTIVE'">
                    {{ trans("Vous êtes connecté et votre offre est toujours en cours.") }}<br />
                    <div v-html="trans('Vous pouvez accéder à votre espace méditation.', { link: route('customer.app.index', { locale: locale }), anchor: 'votre espace méditation' })"></div>
                </div>
                <div v-else-if="!!user && last_subscription_is == 'EXPIRED'">
                    {{ trans("Vous êtes connecté mais votre offre est arrivée à expiration.") }}<br />
                    {{ trans("Si vous possédez un nouveau code, pour continuer entrer le via le bouton ci-dessus.") }}
                </div>
                <div v-else-if="!!user && last_subscription_is == 'NOSUBSCRIPTION'">
                    {{ trans("Vous êtes connecté mais vous ne possédez pas d'offre.") }}<br />
                    {{ trans("Si vous possédez un nouveau code, pour continuer entrer le via le bouton ci-dessus.") }}
                </div>
                <div v-else-if="last_subscription_is_processing" class="text-gray-500">
                    {{ trans("Chargement...") }}
                </div>
            </div>
        </div>

        <h3 class="font-bold text-2xl mb-6">{{ trans("J’ai déjà activé mon code") }}</h3>
        <SecondaryButton v-if="!user" @click="switched = true" class="border-indigo-500 text-md">
            {{ trans('Je me connecte') }}
        </SecondaryButton>
    </div>

    <div v-show="switched" class="space-x-4 text-center">
        <SecondaryButton @click="switched = !switched">
            {{ trans('Retour') }}
        </SecondaryButton>
    </div>

    <Transition>
        <div v-show="switched" class="max-w-xl mx-auto">
            <div v-if="show_social_connexion" class="mt-14">
                <Divider :label="trans('Connexion sociale')" />
                <LoginSocial :subscription="subscription" />
            </div>
            <div>
                <div class="mt-8">
                    <Divider :label="trans('Ou avec votre e-mail')" />
                    <LoginForm :subscription="subscription" />
                </div>
            </div>
        </div>
    </Transition>

</template>